import { useRef, ReactNode } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

interface ParallaxBgProps {
  children: ReactNode;
  bgImage?: string;
  bgColor?: string;
  className?: string;
  overlay?: boolean;
  strength?: number;
}

const ParallaxBg = ({ 
  children, 
  bgImage, 
  bgColor = "bg-primary-900", 
  className = "", 
  overlay = true,
  strength = 0.1
}: ParallaxBgProps) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"]
  });
  
  const y = useTransform(scrollYProgress, [0, 1], ['0%', `${strength * 100}%`]);
  
  return (
    <div 
      ref={ref}
      className={`relative overflow-hidden ${bgColor} ${className}`}
    >
      {bgImage && (
        <motion.div
          style={{ y }}
          className="absolute inset-0 w-full h-full z-0"
        >
          <div 
            className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${bgImage})` }}
          />
          {overlay && <div className="absolute inset-0 bg-primary-900/60" />}
        </motion.div>
      )}
      <div className="relative z-10">{children}</div>
    </div>
  );
};

export default ParallaxBg;
